/**
 * Theme props for Wizard component
 */

export const headerStepCircleSize = '28px';

export const modalSummaryPopupWidth = '380px';
